import { useState } from 'react';

const useSnackbarFields = () => {
  const fieldsDefault = {
    title1: '',
    title2: '',
    backgroundColor: '',
    hoverCloseColor: '',
    focusCloseColor: ''
  };

  enum Types {
    error = 'error',
    success = 'success',
    info = 'info'
  }

  const [fieldsSnackbar, setFieldsSnackbar] = useState(fieldsDefault);

  const validateCommon = (
    errorTest = Types.success,
    title1 = '',
    title2 = ''
  ) => {
    let backgroundColor = '';
    let hoverCloseColor = '';
    let focusCloseColor = '';
    switch (errorTest) {
      case Types.error:
        backgroundColor = '#E8212B';
        hoverCloseColor = '#F85A5E';
        focusCloseColor = '#BA1821';
        break;
      case Types.info:
        backgroundColor = '#5B36F2';
        hoverCloseColor = '#745EF6';
        focusCloseColor = '#4318CD';
        break;

      default: // success
        backgroundColor = '#007F38';
        hoverCloseColor = '#38A456';
        focusCloseColor = '#226C37';
        break;
    }

    setFieldsSnackbar({
      ...fieldsSnackbar,
      title1,
      title2,
      backgroundColor,
      hoverCloseColor,
      focusCloseColor
    });
  };

  return {
    fieldsSnackbar,
    setFieldsSnackbar,
    validateCommon,
    Types
  };
};

export default useSnackbarFields;
